import React, { memo, useMemo } from 'react';
import {
  FormGroup,
  Table as MuiTable,
  Paper,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { MenuProjectionProps, MenuProjectionItem } from '../../../../types/adminInterface';
import MinSingleSelect from '../../MinSingleSelect';
import { SelectChangeEvent } from '@mui/material/Select';
import './table.scss';
import { DayOfWeekOptions } from '../../../../constants';


const AdminMenuProjectionTable: React.FC<MenuProjectionProps> = ({
  data,
  handleMenuProjection,
}) => {
  // Memoize the day-of-week options for stable reference
  const dayOfWeekOptionsMemo = useMemo(() => DayOfWeekOptions, []);
  // Compute the allowed values once (outside of the map)
  const allowedValues = useMemo(() => dayOfWeekOptionsMemo.map((opt) => opt.value), [dayOfWeekOptionsMemo]);

  return (
    <FormGroup className="table-wrapper AdminMenuProjectionTable">
      <TableContainer component={Paper} className="table-inner" sx={{ maxHeight: 425 }}>
        <MuiTable stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>Sr. No.</TableCell>
              <TableCell>User Role</TableCell>
              <TableCell>Week/Month before MP</TableCell>
              <TableCell>Day of the Week</TableCell>
              <TableCell>Date of the Month</TableCell>
              <TableCell>Cut-off Time (HH:MM)</TableCell>
              <TableCell>Alert Email Notification (in mins)</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row: MenuProjectionItem, index: number) => {
              // Use the pre-computed allowedValues from the memo
              const validDayValue = allowedValues.includes(row.dayofweek)
                ? row.dayofweek
                : '';

              return (
                <TableRow key={`${row.userroleid}-${index}`}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>
                    <input type="text" placeholder="" value={row.userrolename} disabled />
                  </TableCell>
                  <TableCell>
                    <input
                      type="number"
                      placeholder=""
                      value={row.weeksbeforeprojection ?? ''}
                      onChange={(e) =>
                        handleMenuProjection(index, 'weeksbeforeprojection', e.target.value)
                      }
                    />
                  </TableCell>
                  <TableCell>
                    <MinSingleSelect
                      options={dayOfWeekOptionsMemo}
                      value={validDayValue}
                      onChange={(event: SelectChangeEvent<any>) =>
                        handleMenuProjection(index, 'dayofweek', event.target.value)
                      }
                      placeholder="Select Day"
                    />
                  </TableCell>
                  <TableCell>
                    <input
                      type="number"
                      value={row.dateofmonth ?? ''}
                      onChange={(e) =>
                        handleMenuProjection(index, 'dateofmonth', e.target.value)
                      }
                    />
                  </TableCell>
                  <TableCell>
                    <div className="time-wrapper flex align-items-center">
                      <input
                        type="number"
                        placeholder="HH"
                        value={row.cutofftimehh ?? ''}
                        onChange={(e) =>
                          handleMenuProjection(index, 'cutofftimehh', e.target.value)
                        }
                      />
                      <span>:</span>
                      <input
                        type="number"
                        placeholder="MM"
                        value={row.cutofftimemm ?? ''}
                        onChange={(e) =>
                          handleMenuProjection(index, 'cutofftimemm', e.target.value)
                        }
                      />
                    </div>
                  </TableCell>
                
                  <TableCell>
                  <div className='minutes flex align-items-center'>
                  <input
                    type="number"
                    value={row.alertnotificationminutes ?? ''}
                    onChange={(e) =>
                      handleMenuProjection(index, 'alertnotificationminutes', e.target.value)
                    }
                  />
                  <span> minutes</span>
                  </div>
                </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </MuiTable>
      </TableContainer>
    </FormGroup>
  );
};

export default memo(AdminMenuProjectionTable);
